import React from 'react'
import './App.sass'
import Preview from './Preview/Preview'
import ModulesComp from './ModulesComp/ModulesComp'
import {Route, Switch} from 'react-router-dom'

export default () => {
  return (
    <Switch>
      <Route path='/modules'>
        <ModulesComp/>
      </Route>
      <Route>
        <Preview/>
      </Route>
    </Switch>
  )
}
